/* tslint:disable */
/* eslint-disable */
export enum PhaseSourceType {
    Ifc = 'IFC',
    Form = 'FORM',
    Undefined = 'UNDEFINED'
}
